import React, { useEffect } from 'react';

import { Modal as AntdModal, Input, Form, ModalProps, Button } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import CommonTemplates from '../FormItems/CommonTemplates';
import { StyledFormItem } from '../FormItems/StyledItem';
import styled from '@emotion/styled';
import { CloseOutlined } from '@ant-design/icons';
import Modal from 'app/components/Modal';
const SectionName = styled(StyledFormItem)`
  label {
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.03em;
    text-align: left;
  }
  margin-bottom: 24px;
`;
const ModalForm = ({
  onCancel,
  open,
  name,
  initialValues,
  title,
  configs
}: ModalProps & {
  // handleClose: () => void;
  name: string;
  initialValues: Record<any, string>;
  configs: any[];
}) => {
  const [form] = Form.useForm();

  const showWarningPopup = (e: any) => {
    e.preventDefault();
    Modal.danger({
      type: 'confirm',
      title: 'Confirm to leave ?',
      content: 'Please ensure your changes have been saved',
      okText: 'Confirm',
      onOk: () => {
        form.setFieldsValue(initialValues);
        if (onCancel) {
          onCancel(e);
        }
      }
    });
  };

  useEffect(() => {
    form.setFieldsValue({ ...initialValues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(initialValues)]);

  return (
    <AntdModal
      centered
      width="80vw"
      closeIcon={
        <Button
          onClick={showWarningPopup}
          type="text"
          icon={<CloseOutlined></CloseOutlined>}
        ></Button>
      }
      destroyOnClose
      open={open}
      title={title}
      cancelButtonProps={{
        onClick: (e) => {
          form.setFieldsValue(initialValues);
          if (onCancel) {
            onCancel(e);
          }
        }
      }}
      onOk={(e) => {
        form.submit();
        if (onCancel) {
          onCancel(e);
        }
      }}
    >
      <Form
        initialValues={initialValues}
        form={form}
        name={name}
        layout="vertical"
      >
        <SectionName name={'value'} label="Section Name">
          <Input></Input>
        </SectionName>

        <FormItem name={'fields'} valuePropName="fields" noStyle>
          <CommonTemplates
            sectionName={name}
            configs={configs}
            rootName={['fields']}
          ></CommonTemplates>
        </FormItem>
      </Form>
    </AntdModal>
  );
};

export default ModalForm;
